// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.shipping-manage .v-tabs-items {\n  background-color: #F1F2F5;\n}\n.shipping-manage .v-expansion-panel-content__wrap {\n  padding: 0 24px 0px;\n}\n.shipping-manage .cod-input input{\n  text-align: right;\n}\n.default-shipping-selection .v-select {\n  max-width: 200px;\n}\n.tracking-option-selection .v-select {\n  max-width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
